import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { I18NextService } from 'angular-i18next';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SessionExpirationService } from '../../services/session-expiration.service';
import { SessionStatus } from '../../utils/jwt-utils';

@UntilDestroy()
@Component({
    selector: 'aum-session-expiration-banner',
    templateUrl: './session-expiration-banner.component.html',
    styleUrls: ['./session-expiration-banner.component.scss'],
    host: {
        '[class.hidden]': 'hide',
    },
})
export class SessionExpirationBannerComponent implements OnInit {
    @Input() warningThresholdHours: number = 2;
    @Input() hide: boolean = false;
    @Output() reAuthenticate = new EventEmitter<void>();
    @Output() dismiss = new EventEmitter<string | null>();
    @Output() idChanged = new EventEmitter<{ newId: string | null; oldId: string | null }>();

    sessionStatus$: Observable<SessionStatus | null>;
    public bannerIdentifier = null;
    constructor(private sessionExpirationService: SessionExpirationService, private i18next: I18NextService) {}

    ngOnInit(): void {
        // Set the warning threshold on the service
        this.sessionExpirationService.setWarningThreshold(this.warningThresholdHours);

        // Get session status updates without filtering nulls - let template handle display
        this.sessionStatus$ = this.sessionExpirationService.getSessionStatus$().pipe(
            map((status) => {
                const oldId = this.bannerIdentifier;
                this.bannerIdentifier = status ? `session-expiration-${status.auth_time}` : null;
                this.idChanged.emit({ newId: this.bannerIdentifier, oldId: oldId });
                return status;
            }),
        );

        // Log when banner should show
        this.sessionStatus$.pipe(untilDestroyed(this)).subscribe();
    }

    onReAuthenticate(): void {
        this.reAuthenticate.emit();
    }

    onDismiss() {
        this.dismiss.emit(this.bannerIdentifier);
    }

    getMessage(status: SessionStatus): string {
        const timeLeft = this.sessionExpirationService.formatTimeUntilExpiry(status.hoursUntilExpiry);
        return this.i18next.t('aumico_session_warning_message', { replace: { timeLeft } }).toString();
    }
}
